import { createSlice } from '@reduxjs/toolkit';

// Change this date to display recent updates for users
const lastUpdate = '2026-06-16';
const showUpdates = !(localStorage.getItem('show-champ-updates') === lastUpdate); 
const version = '2.0.0';

const initialState = {
  cbfriendly: false,
  overviewTab: 'local',
  infoModal: null,
  isChartVisible: false,
  chartTab: 'historical',
  isEpisodeTimelineVisible: false,
  isEventDisplayVisible: false,
  versionBanner: {
    visible: true,
    number: version
  },
  smallScreen: { isSmall: false, reason: '', bypass: false },
  showRecentUpdates: showUpdates
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    changeInfoModal(state, action) {
      state.infoModal = action.payload;
    },
    changeCbFriendly(state, action) {
      state.cbfriendly = action.payload;
    },
    changeOverviewTab(state, action) {
      state.overviewTab = action.payload;
    },
    toggleChartVisible(state) {
      state.isChartVisible = !state.isChartVisible;
    },
    changeChartTab(state, action) {
      state.chartTab = action.payload;
    },
    changeEpisodeTimelineVisible(state, action) {
      state.isEpisodeTimelineVisible = action.payload;
    },
    changeEventDisplayVisible(state, action) {
      state.isEventDisplayVisible = action.payload;
    },
    changeVersionBannerVisible(state, action) {
      state.versionBanner.visible = action.payload;
    },
    changeSmallScreen(state, action) {
      state.smallScreen = action.payload;
    },
    changeShowRecentUpdates(state, action) {
      state.showRecentUpdates = action.payload;
      localStorage.setItem('show-champ-updates', lastUpdate);
    }
  },
});

export const {
  changeInfoModal,
  changeCbFriendly,
  changeOverviewTab,
  toggleChartVisible,
  changeChartTab,
  changeEpisodeTimelineVisible,
  changeEventDisplayVisible,
  changeVersionBannerVisible,
  changeSmallScreen,
  changeShowRecentUpdates
} = uiSlice.actions;
export default uiSlice.reducer;
